import CitySEOHead from "@/components/feature/CitySEOHead";
import LafayetteHeroSection from "./components/HeroSection";
import LafayetteStickyNav from "./components/StickyNav";
import LafayetteProcessingTimeSection from "./components/ProcessingTimeSection";
import LafayetteServicesSection from "./components/ServicesSection";
import LafayetteLocalAreaSection from "./components/LocalAreaSection";
import LafayetteTravelTimingSection from "./components/TravelTimingSection";
import LafayetteDestinationsSection from "./components/DestinationsSection";
import LafayetteTestimonialsSection from "./components/TestimonialsSection";
import LafayetteAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import LafayetteComparisonSection from "./components/ComparisonSection";
import LafayetteMistakesSection from "./components/MistakesSection";
import LafayetteHowItWorksSection from "./components/HowItWorksSection";
import LafayetteFAQSection, { faqs } from "./components/FAQSection";
import LafayetteHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import LafayetteFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

export default function LafayettePage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Lafayette"
        state="Louisiana"
        stateAbbr="LA"
        route="/lafayette"
        title="Emergency Passport Lafayette, LA — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Lafayette, LA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Acadiana oilfield engineers, ULL students, Cajun heritage travelers, and families booking New Orleans cruises."
        geoPlacename="Lafayette, Louisiana"
        geoPosition="30.2241;-92.0198"
        faqs={faqs}
        servicesSchema={[
          { name: "Emergency Passport", description: "Urgent passport processing for Lafayette travelers with immediate departure needs — as fast as 24 hours for Acadiana residents." },
          { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens in Lafayette with an expired or expiring passport." },
          { name: "New Passport", description: "First-time passport application assistance for ULL students and Lafayette families." },
          { name: "Lost or Stolen Passport", description: "Passport replacement for lost or stolen passports with DS-64 form guidance in Lafayette, LA." },
          { name: "Child Passport", description: "Passport services for minors under 16 with parental consent guidance for Acadiana families." },
          { name: "Name Change", description: "Passport correction and name change service for Lafayette residents after marriage or legal changes." },
          { name: "Second Passport", description: "Second passport service for oilfield engineers and frequent international travelers from Lafayette." },
        ]}
        statePageName="Louisiana"
        statePageRoute="/states/louisiana"
      />
      <LafayetteHeroSection />
      <LafayetteStickyNav />
      <LafayetteProcessingTimeSection />
      <LafayetteLocalAreaSection />
      <LafayetteServicesSection />
      <LafayetteTravelTimingSection />
      <LafayetteDestinationsSection />
      <LafayetteTestimonialsSection />
      <LafayetteAcceptanceFacilitiesSection />
      <LafayetteComparisonSection />
      <LafayetteMistakesSection />
      <LafayetteHowItWorksSection />
      <LafayetteFAQSection />
      <LafayetteHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/lafayette" state="LA" />
      <LafayetteFinalCTA />
    </div>
  );
}